import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./CookiePolicy.css";
import { openCookieSettings } from "./cookieConsentStorage";

const CookiePolicy = () => {
  return (
    <Container className="cookie-policy">
      <Row>
        <Col className="text-center">
          <h1 className="cookie-policy-h1-mini">Informacje</h1>
          <h1 className="cookie-policy-h1">Polityka cookies</h1>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col xs={12} md={8}>
          <p>
            Ta strona wykorzystuje pliki cookie (ciasteczka) w minimalnym
            zakresie, niezbędnym do prawidłowego działania strony internetowej i
            funkcji na niej.
          </p>
          <h3 className="cookie-policy-h3">Jakie ciasteczka używamy?</h3>
          <ul>
            <li>
              <strong>cookieConsent</strong> — zapamiętuje Twoją zgodę na
              korzystanie z plików cookie na tej stronie, aby banner nie
              wyświetlał się przy każdej wizycie. Przechowywane przez 180 dni.
            </li>
            <li>
              <strong>Google reCAPTCHA</strong> — ciasteczka ustawiane przez
              Google w celu ochrony formularza kontaktowego przed spamem i
              nadużyciami. Są niezbędne do wysłania wiadomości przez formularz
              kontaktowy.
            </li>
          </ul>
          <p>
            W każdej chwili możesz zmienić swoją decyzję dotyczącą zgody na
            cookie, klikając poniższy przycisk.
          </p>
          <button
            type="button"
            className="btn btn-success"
            onClick={openCookieSettings}
          >
            Zmień ustawienia cookies
          </button>
        </Col>
      </Row>
    </Container>
  );
};

export default CookiePolicy;
